import { createContext, useContext, useEffect, useState } from "react"
import { storage } from "../utils/storage"
import {
  THEME_DARK,
  THEME_LIGHT,
  applyTheme,
  resolveInitialTheme
} from "../utils/theme"

const ThemeContext = createContext({
  theme: THEME_DARK,
  setTheme: () => {},
  toggleTheme: () => {}
})

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(resolveInitialTheme)

  useEffect(() => {
    applyTheme(theme)
    storage.setTheme(theme)
  }, [theme])

  const toggleTheme = () => {
    setTheme((currentTheme) =>
      currentTheme === THEME_DARK ? THEME_LIGHT : THEME_DARK
    )
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  )
}

export function useThemeContext() {
  return useContext(ThemeContext)
}
